export const setToken = (token) => ({
    type: 'SET_TOKEN',
    payload: token,
});